// Drafts the editor has asked to backtest, in memory: the pane whose strategy
// is "draft:<key>" runs the newest source here, and re-runs when it changes.
// The editor also autosaves drafts to the server; after a reload a pane loads
// its draft from there (strategySource.ts).

export interface PublishedDraft {
  readonly name: string
  readonly source: string
  /** Increases with every publish of this key. */
  readonly revision: number
}

const drafts = new Map<string, PublishedDraft>()
const listeners = new Set<(key: string) => void>()
let revisions = 0
let generation = 0

export const userDrafts = {
  get: (key: string): PublishedDraft | undefined => drafts.get(key),
  /** The newest source of a draft: panes backtesting it run again. */
  publish: (key: string, name: string, source: string): void => {
    drafts.set(key, { name, source, revision: ++revisions })
    for (const listener of listeners) listener(key)
  },
  /** The revision a pane's run depends on (0: never published here). */
  revision: (key: string | null): number => (key === null ? 0 : drafts.get(key)?.revision ?? 0),
  subscribe: (listener: (key: string) => void): (() => void) => {
    listeners.add(listener)
    return () => listeners.delete(listener)
  },
  /**
   * Another user signed in (or out): forget this user's drafts. Caches of user
   * strategy code elsewhere (versions, the editor's written drafts) compare
   * `generation` and drop theirs too.
   */
  reset: (): void => {
    drafts.clear()
    generation++
  },
  generation: (): number => generation
}
